<article class="dashboard-widget">
  <ng-template widget-host></ng-template>
</article>
